import React from "react";
import { Table, Badge } from "reactstrap";

const BuildingsTab = ({ assets = [] }) => {
    if (assets.length === 0) {
        return <p className="text-center text-muted py-4">No buildings recorded.</p>;
    }

    return (
        <Table responsive hover bordered className="table-sm">
            <thead style={{ backgroundColor: "#0147C8", color: "white" }}>
                <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th>Name</th>
                    <th>Building No.</th>
                    <th>Plot Size</th>
                    <th>Use</th>
                    <th>Water</th>
                    <th>Electricity</th>
                    <th>Condition</th>
                </tr>
            </thead>
            <tbody>
                {assets.map((a) => {
                    // Determine condition display
                    const condition = a.observed_condition_name || a.observed_condition;
                    const hasCondition = condition && condition.trim() !== "" && condition !== "N/A";
                    
                    return (
                        <tr key={a.id}>
                            <td className="fw-bold text-muted">{a.serialNumber || "-"}</td>
                            <td><strong>{a.name}</strong></td>
                            <td>{a.building_number || "-"}</td>
                            <td>{a.plot_size ? `${a.plot_size.toLocaleString()} m²` : "-"}</td>
                            <td>{a.building_use?.name || "-"}</td>
                            <td>
                                <Badge color={a.has_water ? "success" : "secondary"}>
                                    {a.has_water ? "Yes" : "No"}
                                </Badge>
                            </td>
                            <td>
                                <Badge color={a.has_electricity ? "success" : "secondary"}>
                                    {a.has_electricity ? "Yes" : "No"}
                                </Badge>
                            </td>
                            <td>
                                {hasCondition ? (
                                    condition
                                ) : (
                                    <span style={{ color: "#dc3545", fontWeight: "500" }}>Not Entered</span>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default BuildingsTab;